import React, { Dispatch, SetStateAction } from "react";

const DocumentPopUp = ({
  showDoc,
  setShowDoc,
  docs,
}: {
  showDoc: boolean;
  setShowDoc: Dispatch<SetStateAction<boolean>>;
  docs: string | undefined;
}) => {
  return (
    <>
      {showDoc && (
        <div className="doc-modal-overlay" onClick={() => setShowDoc(false)}>
          <div
            className="doc-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            {docs ? (
              <img
                src={`${process.env.REACT_APP_Url}/${docs}`}
                alt="Document"
                className="w-100"
                style={{ maxHeight: "80vh", objectFit: "contain" }}
              />
            ) : (
              <p>No document available</p>
            )}

            {/* Footer button */}
            <div className="d-flex justify-content-end mt-3">
              <button
                className="btn btn-badge-primary px-5"
                onClick={() => setShowDoc(false)}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DocumentPopUp;